import { render, staticRenderFns } from "./Entities.vue?vue&type=template&id=3246bc01&"
import script from "./Entities.vue?vue&type=script&lang=js&"
export * from "./Entities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports